<template>
  <div class="package-list">
    <h4><i class="text-yellow icon-kolli"></i>{{ $lang.translate('track.label.package')}}</h4>
    <ul class="nav-tabs">
      <li v-for="tab in tabs" :class="{'active': activeTab == tab.code}" :key="tab.code">
        <a href="#" @click.prevent="activeTab = tab.code">{{ tab.label }}</a>
      </li>
    </ul>
    <div class="tab-content" v-show="activeTab == 'delivered'">
      <PackageRow v-for="pkg in deliveredPackages" :totalColli="totalColli" :key="pkg.packageId" :pkg="pkg" :maps="maps" />
    </div>
    <div class="tab-content" v-show="activeTab == 'ontheway'">
      <PackageRow v-for="pkg in undeliveredPackages" :totalColli="totalColli" :key="pkg.packageId" :pkg="pkg" :maps="maps" />
    </div>
  </div>
</template>

<script>
import PackageRow from './PackageRow'

export default {
  props: {
    totalColli: {
      type: Number,
      required: true
    },
    packages: {
      type: Array,
      required: true
    },
    deliveredPackageIds: {
      type: Array,
      required: true
    },
    maps: {
      type: Object
    }
  },
  data () {
    return {
      undeliveredPackages: [],
      deliveredPackages: [],
      activeTab: null,
      tabs: []
    }
  },
  mounted () {
    this.deliveredPackages = this.packages.filter(x => this.deliveredPackageIds.includes(x.packageId))
    this.undeliveredPackages = this.packages.filter(x => !this.deliveredPackageIds.includes(x.packageId))
    this.deliveredPackages.length > 0 && this.tabs.push({code: 'delivered', label: this.$lang.translate('track.tab.delivered')})
    this.undeliveredPackages.length > 0 && this.tabs.push({code: 'ontheway', label: this.$lang.translate('track.tab.onTheWay')})
    this.activeTab = this.tabs[0].code
  },
  components: {
    PackageRow
  }
}
</script>
<style scoped>
i.icon-kolli {
  font-size: 32px;
  top: 5px;
}

.nav-tabs {
  border-bottom: 1px solid #ededed;
  margin-bottom: 0.5rem;
}
.nav-tabs li {
  display: inline-block;
  margin-right: 0.5rem;
  border: 1px solid #ededed;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  border-bottom: none;
  margin-bottom: -1px;
}

.nav-tabs li a {
  display: inline-block;
  background-color: #f4f4f4;
  padding: 0.4rem 1rem;
}

.nav-tabs li.active {
  border-bottom: 1px solid white;
}

.nav-tabs li.active a {
  background-color: white;
}
</style>